import React from "react";
import PropTypes from "prop-types";
import logoWhite from './../../img/logo_total_white.svg'
import {FaSolidIcon} from "../../components/FontAwesomeIcons";
import {BookizonPlusPromoPage} from "./BookizonPlusPromoPage";
import ModalPortalHOC from "../../components/BaseComponents/ModalPortalHOC";
import {BookizonPlusLogo} from "./BookizonPlusLogo";

export class PromoBanner extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isPageOpen: false
        }
        this.bannerStyle = {
            backgroundImage: 'linear-gradient(to right top, #293069, #383d78, #474a87, #565896, #6566a6, #7373b3, #8180bf, #8f8dcc, #9f9cd9, #aface5, #bfbcf2, #cfccff)'
        }
    }

    handleOpenPage = _ => this.setState({isPageOpen: true});
    handleClosePage = _ => this.setState({isPageOpen: false});

    render() {
        return (
            <React.Fragment>
                <div
                    style={this.bannerStyle}
                    className={"d-flex flex-column align-items-center justify-content-center rounded p-3 shadow-sm"}
                    onClick={this.handleOpenPage}
                    role={"button"}
                    tabIndex={0}
                    onKeyDown={event => {
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            this.handleOpenPage();
                        }
                    }}
                >
                    <BookizonPlusLogo/>

                    <h6 className={"text-center text-white"}>
                        Più servizi, più comodità, la stessa app.
                    </h6>
                    <div className={"small text-white"}>
                        Scopri di più <FaSolidIcon name={"chevron-right"}/>
                    </div>
                </div>
                {
                    this.state.isPageOpen &&
                    <ModalPortalHOC>
                        <BookizonPlusPromoPage active={this.state.isPageOpen} onDismiss={this.handleClosePage}/>
                    </ModalPortalHOC>
                }
            </React.Fragment>
        )
    }

}

PromoBanner.propTypes = {}
